<template>
    <div class="epbg">
      <div class="hotCarsTitle">
        <div class="hctMain clearfix">
          <div class="hctMainImg"><img :src="hctIcon" alt=""></div>
          <div class="hctMainTitle">企业背景</div>
        </div>
      </div>
      <div class="epbgMain clearfix">
          <div class="epbgMainImg">
              <van-swipe :autoplay="3000">
              <van-swipe-item v-for="(image, index) in publicData.RYZZ" :key="index">
                  <img v-lazy="image" @click="bigImg(index)" />
              </van-swipe-item>
            </van-swipe>
          </div>
          <p>{{publicData.BackTxt}}</p>
          <!--<p>公司经营租赁车辆种类齐全。可满足不同客户的需求，拥有适合平均需求的多款车型：林肯、 奔驰、宝马、奥迪A6L、别克、凯美瑞、广本、帕萨特、伊兰特。</p>-->
      </div>

    </div>
</template>

<script>
    import ImagePreview from 'vant/lib/image-preview'
    import Notify from 'vant/lib/notify'
    export default {
        name: 'Epbg',
        props:['publicData'],
        data () {
            return {
                epbgMainImg:require("../../assets/icon_ourAdBg01.png"),
                hctIcon:require("../../assets/icon_hotCar.png"),
            }
        },
        methods:{
            bigImg:function (index) {
                var that = this;
                history.pushState(null, null, document.URL);//通过链接打开的浏览器，防退出
                history.pushState(null, null, document.URL);
                window.addEventListener('popstate',that.popstate);
                ImagePreview({images:this.publicData.RYZZ,startPosition:index,onClose:function () {
                        window.removeEventListener('popstate',that.popstate);
                        history.go(-2);
                    }});
            },
            popstate:function() {
                history.pushState(null, null, document.URL);
                Notify('请点击页面任意地方关闭本页面');
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .clear {overflow: hidden;}
    .clearfix:before, .clearfix:after {clear: both;content: " ";display: table;}

    .hotCarsTitle{width: 100%;height: 60px;background: #f6f6f6}
    .hctMain{width: 300px;background: #2c3e50;background: linear-gradient(-45deg, transparent 45px, #2c3e50 0) bottom right;height: 60px; background-repeat: no-repeat;display: flex}
    .hctMainImg{display: flex;padding-left: 20px;box-sizing: border-box;align-items: center;height: 60px;}
    .hctMainImg img{width: 32px;height: 32px;vertical-align: middle}
    .hctMainTitle{display: flex;font-size:32px;font-family:PingFangSC-Semibold;font-weight:600;color:rgba(255,255,255,1);align-items: center;margin-left: 20px;}

    .epbgMain{margin: 30px auto 60px;width: 700px;}
    .epbgMainImg{width: 240px;height: 180px;float: left;margin-right: 24px;overflow: hidden;}
    .epbgMainImg img{width: 100%;height: 100%}
    .epbgMain p{font-size:24px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(77,102,126,1);margin: 0;text-align: left}
</style>
<style>
    .van-image-preview {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        position: fixed;
    }
    .van-image-preview__index {
        position: absolute;
        top: 10px;
        left: 50%;
        color: #fff;
        font-size: 14px;
        letter-spacing: 2px;
        -webkit-transform: translate(-50%, 0);
        transform: translate(-50%, 0);
    }
    .van-image-preview .van-swipe {
        height: 100%;
    }
    .van-image-preview img {
        -webkit-user-drag: none;
    }
    .van-image-preview__image {
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        max-width: 100%;
        max-height: 100%;
        position: absolute;
    }
</style>


// WEBPACK FOOTER //
// src/components/Epbg/Epbg.vue